import { useEffect } from 'react';

export function useEmbedTokenRefresh(expiration: string | undefined, refetch: () => void): void {
  useEffect(() => {
    if (!expiration) return;

    const msUntilExpiry = new Date(expiration).getTime() - Date.now() - 2000;

    if (msUntilExpiry <= 0) {
      refetch();
      return;
    }

    const id = setTimeout(refetch, msUntilExpiry);
    return () => clearTimeout(id);
  }, [expiration, refetch]);
}
